const features = [
  {
    icon: 'ri-speed-up-line',
    title: '极速追踪',
    desc: '7x24小时全天候监测网红圈动态，重大爆料5分钟内上线，让你永远快人一步吃到第一手瓜。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '多方核实',
    desc: '每条爆料标注信息来源与可信度评级，多维度交叉验证，拒绝谣言传播，只做靠谱的网红黑料情报。',
  },
  {
    icon: 'ri-stack-line',
    title: '海量情报',
    desc: '收录超12万条网红黑料情报，涵盖直播翻车、学历造假、情感纠纷等全方位内容，一站吃尽。',
  },
];

export default function Features() {
  return (
    <section id="features" className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">特色优势</h2>
          <p className="mt-2 text-sm text-foreground-500">为什么选择网红黑料作为你的吃瓜情报站</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {features.map((feat) => (
            <div
              key={feat.title}
              className="group p-6 md:p-8 bg-background-100/80 rounded-xl border border-background-200/60 hover:border-accent-200/50 transition-all cursor-pointer"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-accent-100/80 text-accent-600 mb-5 group-hover:bg-accent-500 group-hover:text-white transition-all">
                <i className={`${feat.icon} text-2xl`}></i>
              </div>
              <h3 className="font-heading text-lg font-bold text-foreground-900 mb-2">{feat.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{feat.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}